import SalesTargetReportActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperSalesTargetReport:[],
  errorInternal:false,
  printSalesTargetReport:null
};

function SalesTargetReportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SalesTargetReportActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case SalesTargetReportActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case SalesTargetReportActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case SalesTargetReportActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case SalesTargetReportActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case SalesTargetReportActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case SalesTargetReportActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case SalesTargetReportActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case SalesTargetReportActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case SalesTargetReportActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case SalesTargetReportActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case SalesTargetReportActions.GET_HELPER_SALESTARGETREPORT:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperSalesTargetReport:action.payload};
    case SalesTargetReportActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case SalesTargetReportActions.BEFORE_PRINT_SALESTARGETREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSalesTargetReport:null,isProcessing:true};
    case SalesTargetReportActions.PRINT_SALESTARGETREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSalesTargetReport:action.payload,isProcessing:false};
       
    default:
      return state;
    }
}

export default SalesTargetReportReducer;
